import React from "react";
import Card from "../UI/Card";
import MediumHeading from "../UI/MediumHeading";
import "./tech.scss";



const Specializing = (props) => {

  return (
    <div className="container" style={{ marginTop: "30px" }}>
      <Card style={{ padding: "50px" }}>
        {/*   <SmallHeading text="What I do" /> */}
        <MediumHeading text="I have experience with" />
        <div className="flexRow wrap justify-sa mTop">
          {/* {skills.map((skill, index) => (
            <Skill
              key={index}
              skillName={skill.skillName}
              techImage={skill.techImage}
              desc={skill.desc}
              value={skill.value}
              textColor={colors.primaryColor}
              pathColor={skill.pathColor}
            />
          ))} */}
          <div class="scene1 m">
            <div class="cube1">
              <div class="side1 back1"></div>
              <div class="side1 left1"></div>
              <div class="side1 right1"></div>
              <div class="side1 top1"></div>
              <div class="side1 bottom1"></div>
              <div class="side1 front1"></div>
            </div>
          </div>

          <div class="scene1 m">
            <div class="cube2">
              <div class="side1 back2 "></div>
              <div class="side1 left2 "></div>
              <div class="side1 right2 "></div>
              <div class="side1 top2 "></div>
              <div class="side1 bottom2 "></div>
              <div class="side1 front2 "></div>
            </div>
          </div>

          <div class="scene1 m">
            <div class="cube3">
              <div class="side1 back3"></div>
              <div class="side1 left3"></div>
              <div class="side1 right3"></div>
              <div class="side1 top3"></div>
              <div class="side1 bottom3"></div>
              <div class="side1 front3"></div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Specializing;
